/*
===============================================================================================================
                                 Copyright 2022-2023, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import imageIsValid from './image-validation';
import csvIsValid from './csv-validation';

const validateFile = async ({ file, fileType, validationRules }) => {
  switch (fileType) {
    case 'image': {
      const validationResult = await imageIsValid(file, validationRules);
      return validationResult;
    }
    case 'csv':
      return csvIsValid(file, validationRules);
    default:
      return {
        valid: false,
      };
  }
};

export default validateFile;
